import { PermissionGuard } from '@shared/permissions';
import { APP_PERMISSIONS } from '@user-management/permissions';
import { UserManagementListModalProvider } from '@user-management/user-management-list';
import { Outlet } from 'react-router-dom';

export default function UserManagementLayout() {
  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.SETTING.USER.VIEW]}>
      <UserManagementListModalProvider>
        <Outlet />
      </UserManagementListModalProvider>
    </PermissionGuard>
  );
}
